<template>
  <div class="mainboard">
    <div class="topbar">
      <router-link tag="div"
                   active-class="active"
                   :to="{path: '/index/home'}"
                   class="logo">
        <img src="../../assets/rhino_logo.png"
             alt="logo">
        <h1 style="font-size: 16px;">{{$t('home.犀牛EPOS')}}</h1>
      </router-link>
      <div style="display: flex;">
        <div class="navbar">
          <ul>
            <li v-for="(item, index) in router"
                :class="activeLanguage === 'English' ? 'enMargin' : 'onEnMargin'"
                :key="index">
              <router-link active-class="active"
                           :to="'/index' + item.path">{{item.name}}</router-link>
            </li>
            <li>
              <el-dropdown class="right language"
                trigger="click">
                <span class="el-dropdown-link">
                  {{activeLanguage}}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="item in language"
                    @click.native="changeLanguage(item, 1)"
                    :key="item.language">
                    {{item.title}}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </li>
          </ul>
        </div>
        <div class="router">
          <router-link tag="div"
                       class="management"
                       :to="{ path: '/management' }">{{$t('home.企业后台登录')}}
          </router-link>
          <div class="operation"
               @click="handleJump">{{$t('home.运营管理后台')}}</div>
        </div>
      </div>
    </div>
    <div class="main">
      <transition :name="transitionName"
                  mode="out-in">
        <router-view></router-view>
      </transition>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Index',
  data() {
    return {
      transitionName: '',
      router: [
        {
          id: '1',
          name: this.$t('home.产品'),
          path: '/home'
        },
        {
          id: '2',
          name: this.$t('home.客户'),
          path: '/customer'
        },
        {
          id: '3',
          name: this.$t('home.PC版下载'),
          path: '/PCDownload'
        },
        {
          id: '4',
          name: this.$t('home.移动版下载'),
          path: '/download'
        },
        {
          id: '5',
          name: this.$t('home.定制版下载'),
          path: '/customDownload'
        },
        {
          id: '6',
          name: this.$t('home.联系我们'),
          path: '/contactUs'
        }
      ],
      language: [
        { title: '简体中文', language: 'zh-cn' },
        { title: '繁体中文', language: 'zh-hant' },
        { title: 'English', language: 'en' }
      ],
      activeLanguage: '简体中文'
    }
  },
  created() {
    this.changeLanguage({ title: '简体中文', language: 'zh-cn' }, 0)
    this.language.map(item => {
      if (item.language === window.localStorage.getItem('LOCALE_KEY')) {
        this.activeLanguage = item.title
      }
    })
  },
  watch: {
    activeLanguage() {
      // window.location.reload()
    },
    $route(to, from) {
      let homeRoutes = []
      for (let route of this.$router.options.routes) {
        if (route.path === '/index') {
          homeRoutes = route.children
        }
      }
      let fromIndex = 0
      let toIndex = 0
      for (let i = 0; i < homeRoutes.length; i++) {
        if (homeRoutes[i].name === from.name) {
          fromIndex = i
        }
        if (homeRoutes[i].name === to.name) {
          toIndex = i
        }
      }
      this.transitionName = toIndex < fromIndex ? 'slide-right' : 'slide-left'
    }
  },
  methods: {
    handleJump() {
      window.location.href = process.env.EMB_URL
    },
    changeLanguage(val, type) {
      this.activeLanguage = val.title
      this.$i18n.locale = val.language
      localStorage.setItem('LOCALE_KEY', val.language)
      this.$store.commit('SET_LANGUAGE_CHANGE', val.language)
      if (type) {
        window.location.reload()
      }
    }
  }
}
</script>
<style>
body {
  background-color: #fff;
  position: relative;
}

body::-webkit-scrollbar {
  display: none;
}

/* 可以设置不同的进入和离开动画 */
/* 设置持续时间和动画函数 */
.slide-left-enter-active,
.slide-right-enter-active {
  transition: all 0.5s ease;
}

.slide-left-enter,
.slide-left-leave-to {
  transform: translate(100%);
  opacity: 0;
}

.slide-right-enter,
.slide-right-leave-to {
  transform: translate(-100%);
  opacity: 0;
}
</style>
<style lang="scss" scoped>
.mainboard {
  width: 100%;
  height: 100%;
  background: #fff;
  .active {
    color: #34a6ff;
  }
  .topbar {
    //      box-shadow: 0 -1px 1px 1px #ccc;
    height: 60px;
    width: 100%;
    min-width: 1200px;
    display: flex;
    justify-content: space-between;
    position: fixed;
    left: 0;
    top: 0;
    background-color: #fff;
    z-index: 99999;
    .logo {
      cursor: pointer;
      display: flex;
      line-height: 60px;
      margin-left: 14px;
      img {
        display: block;
        height: 32px;
        margin-top: 14px;
        margin-right: 8px;
      }
      h4 {
        font-size: 16px;
        color: #5c6064;
      }
    }
    .navbar {
      ul {
        display: flex;
        .active {
          color: #34a6ff;
        }
        .enMargin {
          margin-right: 20px;
        }
        .onEnMargin {
          margin-right: 45px;
        }
        li {
          /*width: 82px;*/
          line-height: 60px;
          color: #2e3032;
          font-size: 16px;
          a {
            color: #2e3032;
            text-decoration: none;
          }
        }
        li:last-child {
          width: 114px;
          margin-right: 0;
        }
        li:hover,
        li:active,
        li.selected {
          color: #34a6ff;
        }
      }
    }
    .router {
      display: flex;
      line-height: 32px;
      div {
        cursor: pointer;
        text-align: center;
        margin-left: 20px;
        margin-top: 14px;
        color: #34a6ff;
        border: 1px solid #f1f1f1;
        // width: 110px;
        padding: 0 10px;
        height: 32px;
        border-radius: 4px;
        border: 1px solid #34a6ff;
      }
      .operation {
        margin-right: 14px;
      }
      .operation:hover,
      .operation:active {
        color: #34a6ff;
        border-color: #c2e4ff;
        background-color: #ebf6ff;
      }
      .management {
        background: #34a6ff;
        color: #fff;
      }
      .management:hover,
      .management:active {
        background-color: #5db8ff;
      }
    }
  }

  .main {
    padding-top: 60px;
  }
}
.language {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/pages/index.vue